// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__1y0RW"};